import React, { Component } from 'react';
import './../index.css';
import apiurl from './../apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import NumberFormat from 'react-number-format';
import ZadaniaWydzialoweDodaj from './ZadaniaWydzialoweDodaj';


export default class ZadaniaWydzialowe extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    data: [],
    czyTabela: true,
  }

  this.getdata()
}


getdata = () => {
  let userData = this.props.user;
  axios.get(apiurl+"api/ZadWydzPlan",{ params: { 
      rok: this.props.rok,
      dzial: userData.Dzial,
      rozdzial: userData.Rozdzial,
      paragrafp4: userData.Paragraf + userData.P4,
      pozycja: userData.Pozycja,
      idWydz: userData.idWydzialu,
      dw: userData.DW,
      bp: userData.BP,
      idRodz: userData.idRodzaju,
    }, headers: { 'Authorization' : "Bearer " + this.props.token }})
    .then(response => {
      this.setState({ data : response.data });
    })
    .catch(error => swal(error.response.data.messege) );
}

closeDodaj = () => {
  this.setState({ czyTabela: true })
}

render() {
  let { czyTabela, data } = this.state;


  return (<>
    {czyTabela ? <div className='d-flex container flex-column'>
      <button className='btn btn-light btn-sm ml-auto mr-2' onClick={() => (this.setState({ czyTabela: false }))}>Dodaj pozycje</button>
      <table class="table table-striped mt-2">
        <thead>
          <tr>
            <th scope="col">Rozdział</th>
            <th scope="col">Paragraf</th>
            <th scope="col">Pozycja</th>
            <th scope="col">Kwota wniosku</th>
          </tr>
        </thead>
        <tbody> 
          {data[0]?.plan?.map((arr, idx) => {
            return (
              <tr id={idx}>
                <td>{arr.rozdzial}</td>
                <td>{arr.paragraf}</td>
                <td>{arr.pozycja}</td>
                <td><NumberFormat value={arr.kwota} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div> : <ZadaniaWydzialoweDodaj rok={this.props.rok} token={this.props.token} user={this.props.user} idw={this.props.idw} closeDodaj={this.closeDodaj} />}
  </>);
}
}


